import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const SrRenterApplicationStatusCardSection = ({ title, children, className }) => (
  <div className={classnames('SrRenterApplicationStatusCardSection', className)}>
    <span className="title">{title}</span>
    <span className="message">{children}</span>
  </div>
);

SrRenterApplicationStatusCardSection.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.object.isRequired,
  className: PropTypes.string,
};

SrRenterApplicationStatusCardSection.displayName = 'SrRenterApplicationStatusCardSection';

export default SrRenterApplicationStatusCardSection;
